import axios from 'axios';

export const api = {

  // mockRoute: () => new Promise(function(resolve, reject) {
  //                   setTimeout(function() {
  //                     resolve({
  //                       data: { }
  //                     })
  //                   }, 1000) // throttle to simulate loading data
  // }),

  // User routes
  getScreenTextForLanguage: language => axios.get(`${process.env.PUBLIC_URL}/resources/screenText/${language}.json`),

  getTasksForLanguage: language => axios.get(`${process.env.PUBLIC_URL}/resources/tasks/${language}.xml`, {
    "Content-Type": "application/xml; charset=utf-8"
  }),

  getLectureTasks: category => axios.get(`${process.env.PUBLIC_URL}/resources/lectures/${category}.csv`)
  
}